import { emailTemplateApi } from '@atheneum/api'
import _ from 'lodash'

import moment from 'moment'
import 'moment-timezone'
import { masterTemplateStatic } from '../../../../../api/emailTemplate/helpers/masterTemplate.static'

export const getStage = (state, MPActions) =>
  MPActions[state.massAction?.name]?.stages[state.massAction?.stage]

export const validators = {
  email: {
    fx: item => Boolean(item?.formatted?.emails?.length),
    desc: 'At least one email is required'
  },
  DNC: {
    fx: item =>
      Boolean(item?.data?.sherlock?.allowed && !item?.data?.sherlock?.failed),
    desc: 'Contacting is not allowed allowed (DNC)'
  },
  LPExpert: {
    fx: item => Boolean(item?.data?.expertSync?.expertId),
    desc: 'Expert needs to be created on platform'
  }
}

export const validate = (item, validators) => {
  const res = validators.map(v => ({
    state: v.fx(item),
    desc: v.desc
  }))

  return {
    isValid: !res.find(i => i.state === false),
    details: res
  }
}

// *All comparison done in UTC in milliseconds
export const getScheduledTime = (
  timezone,
  frequency,
  numberOfScheduleTime,
  startTimeInUtc
) => {
  const scheduleArray = []
  // Starting time defaults to time now
  const timeNowInUTC = startTimeInUtc || Date.now()
  // Frequency was in minute
  const frequencyInMs = frequency * 60 * 1000
  // golden hours defined here: https://atheneum-partners.atlassian.net/jira/software/c/projects/AP/boards/30?modal=detail&selectedIssue=AP-2794
  // we could have it as param in the future if neccessary
  let goldenHourArray = [
    { start: 7.5, end: 9.5 },
    { start: 12, end: 14 },
    { start: 17, end: 21 }
  ]
  let now = timeNowInUTC

  const isWithinGoldenHours = (timeInMs, goldenHours) => {
    // Comparison all done in UTC, and output UTC
    // Convert time is ms to time in hour e.g. 1.5 (1:30am)
    // humanReadable for debug purpose
    // const humanReadable = moment.utc(timeInMs).format()
    let timeInHour = moment.utc(timeInMs).hour()
    const timeInMinute = moment.utc(timeInMs).minute()

    // If minute is passed 30 minutes add .5 to hour
    if (timeInMinute > 30) {
      timeInHour += 0.5
    }

    // If the time is within any of golden hour, return that golden hour
    // Else return false
    let isWithin = false

    for (let index = 0; index < goldenHours.length; index++) {
      const { start, end } = goldenHours[index]
      if (timeInHour > start && timeInHour < end) {
        isWithin = true

        break
      }
    }
    return isWithin
  }

  const getDiffInHourToNextGoldenHour = (timeInMs, goldenHours) => {
    // humanReadable for debug purpose
    // const humanReadable = moment.utc(timeInMs).format()
    let timeInHour = moment.utc(timeInMs).hour()
    const timeInMinute = moment.utc(timeInMs).minute()

    // If minute is passed 30 minutes add .5 to hour
    if (timeInMinute > 30) {
      timeInHour += 0.5
    }

    const diffs = goldenHours.map(gh => {
      // Calculate the difference between given time and start of golden hour
      const { start } = gh
      const diff = start - timeInHour
      return diff
    })

    let filterPastTime = diffs.filter(d => d > 0)

    // If all times are in the past, get the difference between first goldenHours start and current time in hour
    if (!filterPastTime[0]) {
      const timeToMidnight = 24 - timeInHour
      const timeToFirstGoldenhour = goldenHours[0].start
      const diffToFirstGoldenhour = timeToMidnight + timeToFirstGoldenhour

      filterPastTime = [diffToFirstGoldenhour]
    }

    const minDiff = Math.min(...filterPastTime)

    return minDiff
  }

  if (timezone) {
    // If timezone we goldenHourArray's content
    const offsetInMinutes = moment.tz(moment.utc(), timezone).utcOffset()
    // Round down to first decimal place
    const offsetInHour = Math.floor((offsetInMinutes / 60) * 10) / 10

    const getHourWithinRange = hour => {
      // start and end range could be out side of the range of 0-23
      // in that case, calculate the difference from 24
      if (hour >= 0 && hour <= 23) {
        return hour
      }
      let finalHour = hour

      if (hour > 23) {
        finalHour = hour - 24
        return finalHour
      }

      if (hour < 0) {
        finalHour = 24 + hour
        return finalHour
      }
    }

    goldenHourArray = goldenHourArray.map(gh => {
      // Because offsetInHour the is how many hour the timezone is different from UTC, subtracting it let us compare it UTC
      let start = gh.start - offsetInHour
      let end = gh.end - offsetInHour
      start = getHourWithinRange(start)
      end = getHourWithinRange(end)

      return {
        start,
        end
      }
    })
  }

  let scheduledTime = now

  // Get the schedule time in milliseconds in the schedule array
  for (let index = 0; index < numberOfScheduleTime; index++) {
    // increment by frequency in milliseconds
    scheduledTime += frequencyInMs

    // Check if time is within golden hours
    const isWithin = isWithinGoldenHours(scheduledTime, goldenHourArray)
    if (isWithin) {
      // If is within golden hours, just push the scheduledTime into the array
      scheduleArray.push(scheduledTime)
      continue
    }

    // If is not within the golden hours, get the next closest golden hour
    const diffInHour = getDiffInHourToNextGoldenHour(
      scheduledTime,
      goldenHourArray
    )
    // Convert hour difference to milliseconds
    scheduledTime = scheduledTime + diffInHour * 60 * 60 * 1000

    scheduleArray.push(scheduledTime)
  }
  return scheduleArray
}

export const getEmailTemplates = async templateGroupName => {
  try {
    const templates = await emailTemplateApi.getByGroup(templateGroupName)
    let initialEmailTemplate

    if (templates && templates[0]) {
      initialEmailTemplate = await emailTemplateApi.get(templates[0].id)
    }
    return {
      templates,
      initialEmailTemplate
    }
  } catch (e) {
    console.error(e)
    return null
  }
}

export const getTemplateType = state => {
  return (
    _.get(
      state.previewTabs[state.selectedTabIndex],
      'selectedTemplate.selectedTemplateType.name'
    ) || state.selectedTemplateType.name
  )
}

export const getGlobalTemplateType = () => {
  const templateType = localStorage.getItem('templateType')
  return templateType
    ? JSON.parse(templateType)
    : masterTemplateStatic.templateTypes.find(option => option.default)
}